import _ from 'lodash';

const STRIPE_JS = 'https://js.stripe.com/v3/';

let loadId: any = null;

export default class StripeAPI {
  static load() {
    if ((window as any).Stripe) {
      return Promise.resolve((window as any).Stripe);
    }

    const $script = require('scriptjs');

    if (!loadId) {
      $script(STRIPE_JS, (loadId = _.uniqueId('stripe')));
    }

    return new Promise(resolve => {
      $script.ready(loadId, () => {
        resolve((window as any).Stripe);
      });
    });
  }
}
